import SalaryCsvSettingAddForm from './SalaryCsvSettingAddForm';

export default SalaryCsvSettingAddForm;
